import _ from 'underscore'
import {createSelector} from 'reselect'
import {getCorporateDays} from '../../../selectors'
import {DateFormat} from '../../../../../date_format'

export const getHolidayListPanelState = state => state.workSchedule.holidayListPanel

export const isShownHolidayList = createSelector(
    getHolidayListPanelState,
    (holidayListPanel) => holidayListPanel.isShow
)

export const isLoadingHolidayList = createSelector(
    getHolidayListPanelState,
    (holidayListPanel) => holidayListPanel.loading
)

export const isShownRemoveAllConfirm = createSelector(
    getHolidayListPanelState,
    (holidayListPanel) => holidayListPanel.isShownRemoveAllConfirm
)

export const getPanelSelectedYear = createSelector(
    getHolidayListPanelState,
    (holidayListPanel) => holidayListPanel.selectedYear
)

export const getHolidays = createSelector(
    getCorporateDays,
    getPanelSelectedYear,
    (corporateDaysByYears, year) => {
        let corporateDaysByMonths = corporateDaysByYears[year]
        if (_.size(corporateDaysByMonths) === 0) return {}
        let holidays = {}
        Object.keys(corporateDaysByMonths).forEach((month) => {
            let corporateDays = corporateDaysByMonths[month]
            Object.keys(corporateDays)
                  .filter((day) => !corporateDays[day].working)
                  .forEach((day) => {
                      holidays[new DateFormat("yyyy-MM-dd").formatDate(new Date(year, month, day))] = corporateDays[day]
                  })
        })
        return holidays
    }
)

export const isListTransformed = createSelector(
    getHolidayListPanelState,
    (holidayListPanel) => holidayListPanel.isListTransformed
)

export const getSorting = createSelector(
    getHolidayListPanelState,
    (holidayListPanel) => holidayListPanel.sorting
)

export const getImportedHolidayDatess = createSelector(
    getHolidayListPanelState,
    (holidayListPanel) => holidayListPanel.importedHolidayDates
)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/selectors.js